export default class CustomListsAndFields {
  constructor(api) {
    this.api = api;
  }

  getCustomFields(queryParams, onSuccess, onError) {
    let params = "";
    const requestParams = {
      ...(queryParams || {}),
      paginate: false,
    };

    if (Object.keys(requestParams).length) {
      for (const [query, value] of Object.entries(requestParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }
    return this.api.http_fibercloud
      .get("v1/customfields" + (params === "" ? "" : params))
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  getCustomFieldByUuid(customFieldUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/customfields/" + customFieldUuid)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  createCustomField(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/customfields", data)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  deleteCustomFieldByUuid(id, ignoreEntry, onSuccess, onError) {
    const url = `v1/customfields/${id}?ignore_entries=${ignoreEntry}`;
    return this.api.http_fibercloud
      .delete(url)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  editCustomField(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/customfields", data)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  getCustomLists(queryParams, onSuccess, onError) {
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }
    return this.api.http_fibercloud
      .get("v1/customlist" + (params === "" ? "" : params))
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  getCustomListByUuid(customListUuid, queryParams, onSuccess, onError) {
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }
    return this.api.http_fibercloud
      .get("v1/customlist/" + customListUuid + (params === "" ? "" : params))
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  createCustomList(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/customlist", data)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }
  deleteCustomList(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/customlist/" + uuid)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  editCustomList(data, listUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .patch("v1/customlist/" + listUuid, data)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  createCustomListValue(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/customlistvalues", data)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  editCustomListValue(data, valueUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .patch("v1/customlistvalues/" + valueUuid, data)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  getCustomListValue(valueUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/customlistvalues/" + valueUuid + "?paginate=false")
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }

  deleteCustomListValue(valueUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/customlistvalues/" + valueUuid)
      .then((resp) => {
        onSuccess(resp);
      })
      .catch((error) => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/customListsAndFields.js